<template>
    <div class="row justify-content-center">
        <div class="col-lg-9">
            <div class="login mt-0 wow zoomIn" data-wow-duration="1.5s">
                <div class="form">
                    <form action="">
                        <span class="login__sub-title text-left mb-2">Company</span>
                        <div class="row mb-5 justify-content-center">

                           <CoverUploader
                               :component-name="`company`"
                               :file="coverFile"
                               @update-cover="updateCompanyCover"
                           />

                            <div class="col-md-8">
                                <div class="row mb-3">
                                    <div class="col-12">
                                        <label class="form-group">
                                            <span class="form-label">Title Company</span>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.name"
                                            >
                                        </label>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input-checkbox"
                                                    v-model="form.isActive"
                                                >
                                                <span class="form-check-label color_primary">Make it Active</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <BaseButtons
                            :on-cancel="backToPreviousPage"
                            :on-save="saveCategoryDetails"
                        />

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import AdminService from "../../services/AdminService";
import CoverUploader from "../Common/CoverUploader.vue";
import BaseButtons from "../Common/BaseButtons.vue";
import ModalHandler from "../../mixins/ModalHandler";

export default defineComponent({
    name: "CompanyEditor",
    components: {BaseButtons, CoverUploader},
    mixins: [ModalHandler],
    props: {
        companyId: {
            type: Number
        }
    },
    data() {
        return {
            companyInfo: null,
            coverFile: null,
            form: {
                name: null,
                isActive: false,
                image: null,
            }
        }
    },
    methods: {
        updateCompanyCover(result) {
            this.coverFile = result
            this.form.image = result.id
        },
        async saveCategoryDetails() {
            this.$showLoadingMessage()
            const uploadMethod = this.companyId
                ? AdminService.updateCompanyDetails(this.companyId, this.form)
                : AdminService.createNewCompany(this.form);

            try {
                await uploadMethod
                this.$showSuccessMessage("The company details was saved");
                window.location.href = '/admin/companies'
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The company was not saved, please try again')
            }
        },
        async getCompanyInfo() {
            try {
                const {data: response} = await AdminService.getCompanyDetails(this.companyId);
                this.form = response
                if(response.image) {
                    this.coverFile = response.image
                    this.form.image = response.image.id
                }
            } catch {
                console.error()
            }
        },
    },
    mounted() {
        if( this.companyId) {
            this.getCompanyInfo()
        }
    }
})
</script>



<style scoped>

</style>
